// @flow

import { useSelector } from 'react-redux'

import { getUser } from '../utils/commonSelectors'

export const useUser = (): Object => useSelector(getUser)
